import { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogActions, DialogTitle, Slide, Stack } from "@mui/material";
import Header from "../../components/Header";
import DebFormModal from "../../components/DebFormModal";
import { DebFormSelect } from "../../components/DebFormComponents";
import DataTable from "../../components/DataTable";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack";
import { company } from "../../services/companies";
import { hook } from "./../../services/appointments-hooks";
import { hooksValidationSchema } from "./../../schemas/appointments-hooks";


//TRANSICIÓN DEL ALERT DE ELIMINACIÓN
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  
const newHookValues = {
    id: "",
    trigger: "",
    action: "",
    company: {
        id: ""
    }
};

const AppointmentsHooks = () => {
    // MODAL DE CREACIÓN
    const [modalState, setModalState] = useState(false);
    const [modalInitialValues, setModalInitialValues] =
        useState(newHookValues);

    const [hooks, setHooks] = useState([]);
    const getHooks = async () => {
        setHooks(await hook.getAll());
    };

    const [companies, setCompanies] = useState([]);
    const getCompanies = async () => {
        setCompanies(await company.getAll());
    };

    useEffect(() => {
        getHooks();
        getCompanies();
    }, []);

    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = async (values) => {
        try {
            const res = await hook.create(values);
            enqueueSnackbar("Hook creado", {
                preventDuplicate: true,
                variant: "success",
            });        
            closeModal();
            getHooks();
        } catch (error) {
                enqueueSnackbar("Ocurrió un error al crear el Hook", {
                    preventDuplicate: true,
                    variant: "error",
                });
        }
    };

    const openModal = () => {
        setModalState(true);
    };

    const closeModal = () => {
        setModalState(false);
        setModalInitialValues(newHookValues);
    };

    const handleCreateHook = () => {
        setModalInitialValues(newHookValues);
        openModal();
    };

     // ALERT DE ELIMINACIÓN
        const [selectedDelete, setSelectedDelete] = useState();
        const [openAlert, setOpenAlert] = useState(false);
        const handleAlertClose = () => {
            setOpenAlert(false);
        };
        const handleAlertOpen = (selectedHook) => {
            setSelectedDelete(selectedHook);
            setOpenAlert(true);
        };

    const handleDelete = async () => {
        try {
            const res = await hook.delete(selectedDelete.id);
            enqueueSnackbar("Se eliminó el Hook " + selectedDelete.system, {
                preventDuplicate: true,
                variant: "success",
            });
            handleAlertClose();
            getHooks();
        } catch (error) {
            enqueueSnackbar("Ocurrió un error eliminando el Hook", {
                preventDuplicate: true,
                variant: "error",
            });
        }
    };

    return (
        <Box>
            <Header title="HOOKS" />
            <DataTable
                loading={!hooks.length}
                rows={hooks}
                columns={[
                    { field: "id", headerName: "ID", flex: 0.1 },
                    {
                        field: "trigger",
                        headerName: "Trigger",
                        flex: 1
                    },
                    {
                        field: "action",
                        headerName: "Acción",
                        flex: 1
                    },
                    {
                        field: "company.id",
                        headerName: "Compañía",
                        flex: 1,
                        renderCell: (params) => {
                            return params?.row?.company?.name ?? "";
                        },
                    },
                ]}
                rowActions={[
                    {
                        label: "Eliminar",
                        icon: <DeleteIcon />,
                        action: handleAlertOpen
                    },
                ]}
                headerActions={[
                    {
                        label: "Crear Hook",
                        icon: <AddBoxIcon />,
                        action: handleCreateHook,
                    },
                ]}
            />

            {/* MODAL DE CREACIÓN */}
            <DebFormModal
                maxWidth="sm"
                fullWidth={true}
                open={modalState}
                onClose={closeModal}
                onReject={closeModal}
                initialValues={modalInitialValues}
                onSubmit={handleSubmit}
                formikProps={{
                    enableReinitialize: true,
                    validationSchema: hooksValidationSchema,
                }}
                headerText={"Crear Licencia"}>
                <Stack spacing={1}>
                    <DebFormSelect
                        label={"Trigger"}
                        name={"trigger"}
                        selectOptions={[
                            { label: "ON_APPOINTMENT_CREATE", value: "ON_APPOINTMENT_CREATE" },
                            { label: "ON_APPOINTMENT_UPDATE", value: "ON_APPOINTMENT_UPDATE" },
                            { label: "ON_APPOINTMENT_DELETE", value: "ON_APPOINTMENT_DELETE" },
                        ]}
                    />
                    <DebFormSelect
                        label={"Acción"}
                        name={"action"}
                        selectOptions={[
                            { label: "SYNC_CUSTOMER_WITH_DEBQ", value: "SYNC_CUSTOMER_WITH_DEBQ" },
                            { label: "ENCRYPTED_CUSTOMER_WITH_DEBQ", value: "ENCRYPTED_CUSTOMER_WITH_DEBQ" },
                            { label: "SEND_APPOINTMENT_CUSTOMER_AND_SCHEDULE_TO_END_POINT", value: "SEND_APPOINTMENT_CUSTOMER_AND_SCHEDULE_TO_END_POINT" },
                            { label: "FIND_AND_REPLACE_CUSTOMER_WITH_DEBQ", value: "FIND_AND_REPLACE_CUSTOMER_WITH_DEBQ" },
                        ]}
                    />
                    <DebFormSelect
                        label={"Compañía"}
                        name={"company.id"}
                        selectOptions={Array.from(companies)?.map((company) => {
                            return {
                                value: company.id,
                                label: company.name,
                            };
                        })}
                    />
                </Stack>
            </DebFormModal>
                    
            {/* ALERT DE ELIMINACIÓN */}
            <Dialog
                open={openAlert}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleAlertClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle sx={{m:"2rem 3rem 1rem 3rem", gap:"1rem", p:"0"}} >{"¿Esta seguro que desea eliminar?"}</DialogTitle>
                <DialogActions>
                <Button onClick={handleAlertClose} variant="outlined" color="error">Cancelar</Button>
                <Button onClick={handleDelete} variant="contained" color="success">Confirmar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default AppointmentsHooks;
